// extracted by mini-css-extract-plugin
export var contentWrap = "featured-block-module--contentWrap--fafcf";
export var grid = "featured-block-module--grid--923c8";
export var heading = "featured-block-module--heading--86d0b";
export var image = "featured-block-module--image--5b715";
export var root = "featured-block-module--root--ffa46";
export var subtitle = "featured-block-module--subtitle--f8c3d";
export var switchOrder = "featured-block-module--switchOrder--a6545";
export var text = "featured-block-module--text--ff1c0";